export enum GeolocationPromptType {
  Mandatory = 'mandatory',
  Skippable = 'skippable',
}

export enum GeolocationOutcome {
  Granted = 'granted',
  Denied = 'denied',
  Skipped = 'skipped',
}

export enum GeolocationCurrentPermission {
  NotRequested = 'notRequested',
  Denied = 'denied',
}

export enum GeolocationPermissionStatus {
  NotRequested = 'notRequested',
  Granted = 'granted',
  DeniedOnce = 'deniedOnce',
  DeniedAlways = 'deniedAlways',
  ServicesDisabled = 'servicesDisabled',
  Unknown = 'unknown',
}

export enum ForeignIpVerdict {
  Allow = 'Allow',
  PromptMandatory = 'PromptMandatory',
  PromptSkippable = 'PromptSkippable',
  HardBlockSanctioned = 'HardBlockSanctioned',
  HardBlockStreak = 'HardBlockStreak',
}

export enum ForeignIpBlockedScreenKind {
  TransferNotAvailable = 'transferNotAvailable',
  AccountRestricted = 'accountRestricted',
}

export enum ForeignIpGeolocationScreen {
  Mandatory = 'mandatory',
  Skippable = 'skippable',
  Rationale = 'rationale',
  Settings = 'settings',
  MockGps = 'mockGps',
}

export type ForeignIpGeolocationScreenAction = 'continue' | 'skip' | 'settings' | 'back';

export interface IForeignIpGeolocationScreenResult {
  action: ForeignIpGeolocationScreenAction;
}



// WEBPACK FOOTER //
// ./src/model/types/geolocation-compliance-type.ts